<template>
  <div class="caution-maintenance-section" :class="[{ smartphone: isSmartPhone }]">
    <p class="caution-maintenance-section__title">{{ cautionMessageInfo.title }}</p>
    <p v-html="cautionMessageInfo.message" class="caution-maintenance-section__message"></p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import type { CautionMessageInfoType } from '@/store/stores/collectionModule/documents/GeneralTypes'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * メンテナンス表示のセクション。
 */
export default defineComponent({
  name: 'CautionMaintenanceSection',
  props: {
    cautionMessageInfo: {
      type: Object as PropType<CautionMessageInfoType>,
      required: true,
    },
  },
  setup() {
    /** スマートフォンかどうか */
    const isSmartPhone = computed(DeviceInfo.isSmartPhone)

    return {
      isSmartPhone,
    }
  },
})
</script>

<style lang="scss" scoped>
.caution-maintenance-section {
  max-width: 375px;
  padding: 10px;
  margin: 20px auto 10px;
  border-radius: 5px;
  background: #f5f5f5;
  text-align: center;

  &__title {
    margin-bottom: 0.8rem;
    color: #b80727;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
  }

  &__message {
    background: transparent;
    font-size: 12px;
  }
}

.smartphone {
  margin: 20px 12px 10px;

  .caution-maintenance-section {
    &__title {
      font-size: 12px;
    }

    &__message {
      font-size: 11px;
    }
  }
}
</style>
<style lang="scss">
strong {
  font-weight: bold;
}
</style>
